import { apiRoutes } from "@constants/api-routes";
import { RpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { injectRpServiceId } from "@utils/parameter-injector";
import { handleRequest } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";

export const getRpServiceConfigurationRequest = async (rpServiceId: string): Promise<{ data: RpServiceConfiguration, error: any }> => {
    const route = injectRpServiceId(apiRoutes.serviceConfiguration.rpServiceConfig.axn.rpService, rpServiceId);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};